export enum CertificateRecordStatusEnum {
    Valid = 0,
    Replaced = 1,
    Expired = 2,
}
